<template>
  <div>
    <headerNav title="会员邀请" />

    <div class="mystep" :style="{ background: '#fff' }">
      <mystep :stepinfos="stepinfos" :active="active"></mystep>
    </div>

    <div v-if="active == 0">
      <div>
        <van-field :value="'  上       级：' + inviterinfo.parentName" readonly>
          <template #left-icon>
            <van-icon
              :size="$abctheme.fontbig"
              :color="$abctheme.basecolor"
              class-prefix="abc-icon"
              name="shangji"
            />
          </template>
        </van-field>
        <van-field
          v-if="inviterinfo.refName"
          readonly
          :value="'  推  荐  人：' + inviterinfo.refName"
        >
          <template #left-icon>
            <van-icon
              :size="$abctheme.fontbig"
              :color="$abctheme.basecolor"
              class-prefix="abc-icon"
              name="shangji"
            />
          </template>
          |</van-field
        >
        <van-field
          :value="'  邀  请  人：' + inviterinfo.inviterName"
          readonly
          v-if="inviterinfo.inviterName"
        >
          <template #left-icon>
            <van-icon
              :size="$abctheme.fontbig"
              :color="$abctheme.basecolor"
              class-prefix="abc-icon"
              name="shangji"
            />
          </template>
        </van-field>
        <van-field :value="'  品       牌：群婴汇'" readonly>
          <template #left-icon>
            <van-icon
              :size="$abctheme.fontbig"
              :color="$abctheme.basecolor"
              name="gift-o"
            />
          </template>
        </van-field>
        <van-field :value="'  品牌等级：' + inviterinfo.levelName" readonly>
          <template #left-icon>
            <van-icon
              :size="$abctheme.fontbig"
              :color="$abctheme.basecolor"
              name="gift-o"
            />
          </template>
        </van-field>
        <van-field :value="'  保  证  金：' + inviterinfo.earnestMoney" readonly>
          <template #left-icon>
            <van-icon
              :size="$abctheme.fontbig"
              :color="$abctheme.basecolor"
              name="bill-o"
            />
          </template>
        </van-field>
        <van-field :value="'  首充金额：' + inviterinfo.firstRechargeMoney" readonly>
          <template #left-icon>
            <van-icon
              :size="$abctheme.fontbig"
              :color="$abctheme.basecolor"
              name="bill-o"
            />
          </template>
        </van-field>
      </div>
    </div>

    <div v-if="active == 1">
      <div>
        <van-field v-model="memberInfo.userName" placeholder="手机号">
          <template #left-icon>
            <van-icon
              :size="$abctheme.fontbig"
              :color="$abctheme.basecolor"
              class-prefix="abc-icon"
              name="shouji"
            />
          </template>
        </van-field>
        <van-field
          v-model="memberInfo.phoneCode"
          center
          clearable
          placeholder="短信验证码"
          v-if="systemset.isRegisterSms"
        >
          <template #left-icon>
            <van-icon
              :size="$abctheme.fontbig"
              :color="$abctheme.basecolor"
              class-prefix="abc-icon"
              name="yanzhengma2"
            />
          </template>
          <template #button>
            <van-button
              size="small"
              type="info"
              @click="sendcode"
              :disabled="sendcodestr != '发送验证码'"
              native-type="button"
              :color="$abctheme.basecolor"
              >{{ sendcodestr }}</van-button
            >
          </template>
        </van-field>
        <van-field v-model="memberInfo.dealerName" placeholder="真实姓名">
          <template #left-icon>
            <van-icon
              :size="$abctheme.fontbig"
              :color="$abctheme.basecolor"
              class-prefix="abc-icon"
              name="xingming"
            />
          </template>
        </van-field>
        <van-field v-model="memberInfo.password" placeholder="密码" type="password">
          <template #left-icon>
            <van-icon
              :size="$abctheme.fontbig"
              :color="$abctheme.basecolor"
              class-prefix="abc-icon"
              name="mima"
            />
          </template>
        </van-field>
        <van-field v-model="memberInfo.password2" placeholder="验证密码" type="password">
          <template #left-icon>
            <van-icon
              :size="$abctheme.fontbig"
              :color="$abctheme.basecolor"
              class-prefix="abc-icon"
              name="mima"
            />
          </template>
        </van-field>

        <van-field v-model="memberInfo.wxNumber" placeholder="微信号">
          <template #left-icon>
            <van-icon
              :size="$abctheme.fontbig"
              :color="$abctheme.basecolor"
              class-prefix="abc-icon"
              name="weixinhao"
            />
          </template>
        </van-field>
        <van-field v-model="memberInfo.cardNumber" placeholder="身份证号">
          <template #left-icon>
            <van-icon
              :size="$abctheme.fontbig"
              :color="$abctheme.basecolor"
              class-prefix="abc-icon"
              name="shenfenzheng"
            />
          </template>
        </van-field>
        <div class="car-upload">
          <div class="car-nupload-conf">
            <van-uploader
              upload-text="上传身份证正面照片"
              v-model="fileList"
              :max-count="1"
              :after-read="afterRead"
              accept="image/*"
            >
            </van-uploader>
          </div>
          <div class="car-nupload-conf">
            <van-uploader
              upload-text="上传身份证反面照片"
              v-model="fileList1"
              :max-count="1"
              :after-read="afterRead1"
              accept="image/*"
            >
            </van-uploader>
          </div>
        </div>
        <van-field
          readonly
          required
          clickable
          :value="value"
          placeholder="地区选择"
          @click="showArea = true"
        >
          <template #left-icon>
            <van-icon
              :size="$abctheme.fontbig"
              :color="$abctheme.basecolor"
              class-prefix="abc-icon"
              name="diqu"
            />
          </template>
        </van-field>
        <van-popup v-model="showArea" position="bottom">
          <van-area
            :area-list="areaList"
            @confirm="onConfirm"
            @cancel="showArea = false"
          />
        </van-popup>
        <van-field v-model="memberInfo.receiverAddress" placeholder="详细地址、门牌号">
          <template #left-icon>
            <van-icon
              :size="$abctheme.fontbig"
              :color="$abctheme.basecolor"
              class-prefix="abc-icon"
              name="diqu"
            />
          </template>
        </van-field>
      </div>
    </div>

    <div class="v-btns">
      <van-button round block type="info" :color="$abctheme.basecolor" @click="next">{{
        active == 0 ? "下一步" : active == 1 ? "注册" : "去登录"
      }}</van-button>
      <van-button
        style="margin-top: 10px"
        round
        block
        type="info"
        :color="$abctheme.basecolor"
        @click="wxregist"
        v-if="inviterinfo.isRetail"
        >微信授权注册</van-button
      >
    </div>
    <div class="v-btns" v-if="active > 0">
      <van-button round block type="info" :color="$abctheme.basecolor" @click="last"
        >上一步</van-button
      >
    </div>
    <!-- <van-form @submit="onSubmit">
      
      <van-field
        v-model="memberInfo.dealerName"
        placeholder="请输入真实姓名"
        required
        label="姓名"
        :rules="[{required:true}]"
      />
      <van-field v-model="memberInfo.wxNumber" placeholder="请输入微信号" required label="微信号" />
      <van-field v-model="memberInfo.cardNumber" placeholder="请输入身份证号" required label="身份证号码" />
      <van-field
        readonly
        required
        clickable
        name="area"
        :value="value"
        label="地区选择"
        placeholder="点击选择省市区"
        @click="showArea = true"
      />
      <van-popup v-model="showArea" position="bottom">
        <van-area :area-list="areaList" @confirm="onConfirm" @cancel="showArea = false" />
      </van-popup>
      <van-field
        v-model="memberInfo.receiverAddress"
        placeholder="请输入详细地址 门牌号"
        required
        label="详细地址"
      />
      <div style="margin: 16px;">
        <van-button block type="info" native-type="submit">注册</van-button>
      </div>
    </van-form> -->
  </div>
</template>
<script>
import areaList from "../../data/area";
import Util from "@/config/Util";
import appconst from "../../config/appconst";
export default {
  data() {
    return {
      stepinfos: [
        {
          steptxt: "1",
          txt: "注册信息",
        },
        {
          steptxt: "2",
          txt: "填写资料",
        },
        {
          steptxt: "3",
          txt: "授权审核",
        },
      ],
      curcolor: "rgb(227,107,161)",
      active: 0,
      showArea: false,
      areaList,
      inviterinfo: {},
      memberInfo: {},
      value: "",
      sendcodestr: "发送验证码",
      sendcodesec: 60,
      earnestMoney: 0,
      fileList: [],
      fileList1: [],
      isloadok:false,
      systemset:undefined
    };
  },
  beforeCreate() {
      var code = this.getQueryVariable("code");
      if (code) {
        let levelid = this.getQueryVariable('levelid');
        let dguid = this.getQueryVariable('dguid');
        const registMethod = this.getQueryVariable('registMethod');
        let m ={};
        m.parentDguid = dguid;
        m.levelId = levelid;
        m.registMethod = registMethod;
        localStorage.setItem("registinfo", "");
        m.code = code;
        this.ajax.post("/api/TokenAuth/WxOAuthorization", m).then((req) => {
          var tokenExpireDate = new Date(
            new Date().getTime() + 1000 * req.result.expireInSeconds
          );

          Util.abp.auth.setToken(req.result.accessToken, tokenExpireDate);
          Util.abp.utils.setCookieValue(
            appconst.authorization.encrptedAuthTokenName,
            req.result.encryptedAccessToken,
            tokenExpireDate,
            Util.abp.appPath
          );
          var sku= this.getQueryVariable('sku')||"";
          var cururl="http://" + location.host;
          if(sku)
          {
             cururl+="/#/product/"+sku;
          }
          location.href = cururl;
          return;
        });

        return;
      }
    
  },
  created() {
    //登录进来的判断是否 已经注册
    //登录进去但是没有缴纳保证金

    //这里不需要判断等级 如果没有等级 就给最低等级
    let levelid = this.$route.query.levelid;
    let dguid = this.$route.query.dguid;
    const registMethod = this.$route.query.registMethod;
    if (!dguid) {
      console.log("无推荐人不允许注册");
      this.$router.push({
        path: "/login",
      });
    }
    this.memberInfo.parentDguid = dguid;
    this.memberInfo.levelId = levelid;
    this.memberInfo.registMethod = registMethod;

    this.ajax
      .post("/api/services/app/PhoneCom/QueryMemberInfoByDGuid", {
        dguid: dguid,
        levelId: levelid,
        registMethod: registMethod,
      })
      .then((x) => {
        this.inviterinfo = x.result;
        // if (this.inviterinfo.isRetail) {
        //   this.wxregist();
        // }
      });
      this.ajax.post("/api/services/app/PhoneCom/QueryFunctionSetting").then(x=>
      {
          this.systemset=x.result;
      }).finally(x=>
      {
        this.isloadok=true;
      })
      


  },
  methods: {
    sendcode() {
      if (!this.memberInfo.userName || this.memberInfo.userName.length != 11) {
        this.$toast.fail("请填写用户名,用户名必须为手机号");
        return;
      }
      this.ajax
        .post("/api/services/app/PhoneCom/QueryVeryCode", {
          phoneNum: this.memberInfo.userName,
          verifyCodeType: 1,
        })
        .then(() => {
          this.$toast.success("发送成功");
          this.sendcodesec = 60;
          let sendcodeinterval = setInterval(() => {
            this.sendcodestr = this.sendcodesec + "秒后重新发送";
            this.sendcodesec--;
            if (this.sendcodesec == 0) {
              clearInterval(sendcodeinterval);
              this.sendcodestr = "发送验证码";
            }
          }, 1000);
        });
    },
    afterRead(file) {
      var formData = new FormData(); //构造一个 FormData，把后台需要发送的参数添加
      formData.append("file", file.file); //接口需要传的参数
      this.ajax
        .post("/File/SaveCardPic", formData)
        .then((x) => {
          var imgurl = x.result.data[0];
          this.memberInfo.cardHeadPic = imgurl;
          console.log("打印图片路径:" + x);
        })
        .catch(() => {
          if (this.memberInfo.cardBackPic) {
            this.fileList = [this.memberInfo.cardHeadPic];
          }
        });
    },
    afterRead1(file) {
      var formData = new FormData(); //构造一个 FormData，把后台需要发送的参数添加
      formData.append("file", file.file); //接口需要传的参数
      this.ajax
        .post("/File/SaveCardPic", formData)
        .then((x) => {
          var imgurl = x.result.data[0];
          this.memberInfo.cardBackPic = imgurl;
        })
        .catch(() => {
          if (this.memberInfo.cardBackPic) {
            this.fileList1 = [this.memberInfo.cardBackPic];
          }
        });
    },
    onConfirm(values) {
      console.log(values);
      this.value = values.map((item) => item.name).join("/");
      this.memberInfo.receiverState = values[0].name;
      this.memberInfo.receiverCity = values[1].name;
      this.memberInfo.receiverDistrict = values[2].name;
      this.memberInfo.areaCode = values[2].code;
      this.showArea = false;
    },
    next() {
      if (this.active == 0) {
        this.active = 1;
        return;
      }
      if (this.active == 1) {
        if (this.memberInfo.password != this.memberInfo.password2) {
          this.$toast.fail("两次输入密码不一致");
          return;
        }
        
        this.ajax
        .post("/api/services/app/PhoneAccount/ValidePhoneCode", this.memberInfo)
        .then(() => {
          this.onSubmit();
        });
      }
      if (this.active == 2) {
        this.onlogin();
      }
    },
    last() {
      this.active--;
    },
    onlogin() {
      this.$router.push({
        path: "/login/password",
      });
    },
    onSubmit() {
      if (this.memberInfo.password != this.memberInfo.password2) {
        this.$toast.fail("两次输入密码不一致");
        return;
      }

      this.ajax
        .post("/api/services/app/PhoneAccount/RegistMember", this.memberInfo)
        .then(() => {
          this.active = 2;
          this.$toast.success("注册成功,通过审核后即可登录");
        });
    },
    wxregist() {
      if (process.env.NODE_ENV == "production") {
        localStorage.setItem("registinfo", JSON.stringify(this.memberInfo));
        location.href =
          "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" +
          appconst.wxappid +
          "&redirect_uri=http%3A%2F%2f" +
          location.host +
          "%2F%23%2Finviteregist" +
          "&response_type=code&scope=snsapi_userinfo&state=1001#wechat_redirect";
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.mystep {
  padding: 20px 0 20px 0;
}
.car-upload {
  background-color: #fff;
  padding: 10px;
  font-size: 14px;
  text-align: center;
}
.car-nupload-conf {
  display: inline-block;
  width: 46%;
  vertical-align: top;
}
.car-nupload-conf-vinfo {
  height: 80px;
  background-color: #d2d2d2;
  text-align: center;
  border-radius: 4px;
}
.van-uploader {
  position: relative;
  display: block;
}
.car-nupload-conf:first-child {
  margin-right: 4%;
}
.v-btns {
  width: 200px;
  text-align: center;
  margin: 20px auto;
}
</style>
<style lang="scss" scoped>
.van-uploader__wrapper {
  width: 100%;
  display: block;
}

.van-uploader__upload {
  width: 100%;
}
.van-uploader__preview-image {
  width: 100%;
  height: 80px;
}
</style>
